import Vue from 'vue';
import {UPDATE_CURRENT_LEADER_INFO} from '../mutation.type';

const state = {
    leader_info: {}
}

const mutations = {
    [UPDATE_CURRENT_LEADER_INFO]: (state, {key, value}) => {
        Vue.set(state.leader_info, key, value);
    },
}

export default {
    state,
    mutations,
}